/* eslint-disable max-len */

const RemoveIcon = ({ colorTheme }: {colorTheme: string}) => {

  const svg = `
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width="24" height="24" rx="12" fill="${colorTheme}"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.79 11.7835C12.79 11.3475 11.6471 11.8494 11.211 11.8494V11.8089H7.78947C7.35346 11.8089 7 12.1623 7 12.5984C7 13.0344 7.35346 13.3878 7.78947 13.3878H11.211C11.211 13.3878 12.79 13.3971 12.79 13.3917V13.3878H16.2105C16.6465 13.3878 17 13.0344 17 12.5984C17 12.1623 16.6465 11.8089 16.2105 11.8089H12.79C12.79 11.8089 12.79 12.2196 12.79 11.7835Z" fill="white"/>
    </svg>
  `;

  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export default RemoveIcon;
